import { useSelector } from 'react-redux';
import { RootState } from '../../ReduxToolkit/Store';
import { Col } from 'reactstrap';
import HorizontalLogo from './HeaderLeft/HorizontalLogo';
import { H2, UL } from '../../AbstractElements';
import UserWrap from './HeaderRight/UserWrap';

export default function Header() {
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);

    return (
        <header className={`page-header row ${sideBarToggle ? 'close_icon' : ''}`}>
            <HorizontalLogo />
            <Col className="page-main-header d-flex align-items-center justify-content-between">
            <H2 className="heading-color mx-auto text-center">
                  Welcome to  CRM 
                </H2>
                <UL className="header-right simple-list flex-row">
                    <UserWrap />
                </UL>
            </Col>
        </header>
    );
}
